import customaxios from ".";
import qs from "qs";

export const getProviderById = (providerId: number) => {
  return customaxios({
    method: "GET",
    url: `/provider/${providerId}`,
  });
};

export const getProviderDetailsById = (providerId: number, params: any) => {
  return customaxios({
    method: "GET",
    url: `/provider/details/${providerId}`,
    params
  });
};
export const getProviderReviewsById = (providerId: number) => {
  return customaxios({
    method: "GET",
    url: `/reviews/partner/${providerId}`,
  });
};

export const getSimilarProvidersById = (providerId: number) => {
  return customaxios({
    method: "GET",
    url: `/provider/similar-providers/${providerId}`,
  });
};

export const toggleFavoriteProvider = (providerId: number) => {
  return customaxios({
    method: "POST",
    url: `/provider/favorite/${providerId}`,
  });
};
export const submitReview = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/reviews/upsert`,
    data,
  });
};
export const deleteReview = (providerId: number, data: any) => {
  return customaxios({
    method: "DELETE",
    url: `/reviews/partner/${providerId}`,
    data
  });
};

export const openGoogleMapsDirections = (
  latitude: number,
  longitude: number
) => {
  if (latitude && longitude) {
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
    window.open(googleMapsUrl, "_blank");
  } else {
    console.warn("Latitude or longitude is missing");
  }
};

export const sharePartnerEmail = (providerId: number, data: any) => {
  return customaxios({
    method: "POST",
    url: `/provider/share-details/${providerId}`,
    data
  });
};

export const providerAutoSuggestions = (searchText: string) => {
  return customaxios({
    method: "GET",
    url: `/provider/search/query?text=${searchText}`,
  });
};

export const getProviderBySearchText = (params: {
  businessName?: string;
  type?: string;
  state?: string;
  city?: string;
  text?: string;
}) => {
  const query = qs.stringify(params);
  return customaxios({
    method: "GET",
    url: `/provider/search/query/listing?${query}`,
  });
};
